import intlTelInput from "intl-tel-input";
import utilsScript from "intl-tel-input/build/js/utils";
import first from "lodash/fp/first";

function Directive($http) {
  "ngInject";
  return {
    restrict: "A",
    require: "?ngModel",
    scope: {
      iti: "=",
    },
    link: (scope, elm, attrs, ctrl) => {
      const errorMap = [
        "Invalid number!",
        "Invalid country code!",
        "Too short!",
        "Too long!",
        "Invalid number!",
      ];
      const element = first(elm);
      const reset = function () {
        const errorMsg = document.querySelector("#error-msg");
        const validMsg = document.querySelector("#valid-msg");
        if (errorMsg && errorMsg.innerHTML) {
          errorMsg.classList.add("hide");
        }
        if (validMsg && validMsg.innerHTML) {
          validMsg.classList.add("hide");
        }
      };

      const iti = intlTelInput(element, {
        initialCountry: "auto",
        geoIpLookup(callback) {
          $http({
            method: "GET",
            url: "https://ipinfo.io",
          }).then(
            (resp) => {
              const countryCode = resp && resp.country ? resp.country : "";
              callback(countryCode);
            },
            (response) => {
              console.error("Error in geolookup data", response);
            }
          );
        },
        utilsScript,
      });

      scope.iti = iti;

      if (ctrl && ctrl.$validators) {
        reset();
        // This will overwrite the default AngularJS email validator
        ctrl.$validators.required = function () {
          const errorMsg = document.querySelector("#error-msg");
          const validMsg = document.querySelector("#valid-msg");

          if (element.value.trim()) {
            if (iti.isValidNumber()) {
              validMsg.classList.remove("hide");
              errorMsg.classList.add("hide");
              return true;
            }
            const errorCode = iti.getValidationError();
            if (errorMsg && errorMsg.innerHTML) {
              errorMsg.classList.remove("hide");
              errorMsg.classList.add("error");
              validMsg.classList.add("hide");
              errorMsg.innerHTML = errorMap[errorCode] || "Invalid number!";
            }
            return false;
          }
          return false;
        };
      }

      // On blur: validate
      element.addEventListener("blur", () => {
        reset();
        element.placeholder = "";
        const errorMsg = document.querySelector("#error-msg");
        const validMsg = document.querySelector("#valid-msg");
        if (element.value.trim()) {
          if (iti.isValidNumber()) {
            validMsg.classList.remove("hide");
          } else {
            errorMsg.classList.add("error");
            errorMsg.classList.remove("hide");
            const errorCode = iti.getValidationError();
            errorMsg.innerHTML = errorMap[errorCode] || "Invalid number!";
          }
        }
        if (element.value.length === 0) {
          errorMsg.innerHTML = "Phone number is required!";
          errorMsg.classList.add("error");
          errorMsg.classList.remove("hide");
          validMsg.classList.add("hide");
        }
      });

      function setSelectedCountryData(countryCode) {
        const country = document.querySelector("#country");

        country.setAttribute("value", countryCode);
      }

      function handleCountryChange(cc) {
        setSelectedCountryData(cc);
      }

      element.addEventListener("countrychange", function () {
        const countryCode = iti.getSelectedCountryData().iso2;
        handleCountryChange(countryCode);
      });
    },
  };
}

export default Directive;



// WEBPACK FOOTER //
// ./src/directives/intlTelInput/intlTelInput.directive.js